export function getColor(path) {
  let light = ['/product-edit', '/product-detail'];
  let dark = ['/training', '/'];
  if (light.includes(path)) {
    return 'black';
  } else if (dark.includes(path)) {
    return 'white';
  }
}
